import { useCallback, useRef, useState } from 'react'

export function useElementHeight<T extends HTMLElement>() {
  const [height, setHeight] = useState(0)
  const observerRef = useRef<ResizeObserver | null>(null)

  // Callback ref: (re)attaches whenever the element mounts, even if it is
  // rendered after the first render (e.g. behind a loading early return).
  // React calls it with null on unmount, which disconnects the observer.
  const ref = useCallback((el: T | null) => {
    observerRef.current?.disconnect()
    observerRef.current = null
    if (!el) return

    // Border-box height (includes padding + border), so sticky offsets
    // computed from it line up with the element's real visual height
    const observer = new ResizeObserver(([entry]) => {
      setHeight(entry.borderBoxSize?.[0]?.blockSize ?? el.offsetHeight)
    })
    observer.observe(el)
    observerRef.current = observer
  }, [])

  return { ref, height }
}
